module.exports = __webpack_public_path__ + "img/sp.fdc672db.png";